<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Space-Vorlage erstellen</h2>
        <div class="input-row">
            <inputFloatLabel style="width: 48%" label="Vorlagenname" @input="moduleNameChanged"
                             :value="spaceName"></inputFloatLabel>
            <inputFloatLabel style="width: 48%" label="Technischer Name" @input="technicalNameChanged"
                             :value="technicalName"></inputFloatLabel>
        </div>
        <div class="item-row">
            <!--            <InputFloatLabel style="width: 200px"
                                         class="setupInfos" icon-size="2.4em" :value="this.deviceType" label="Mediumbezeichnung"
                                         :icon="this.deviceMapping[this.deviceType]['icon']" iconColor="#D70465"
                                         @click="this.toggleDevice"
                                         @input="deviceInput">
                        </InputFloatLabel>-->
            <div class="add-buttons">
                <AdaButton style="margin-right: 10px" :custom-styles="addModuleStyles" title="MODUL-VORLAGE LADEN"
                           @click="openAddModulesDialog" type="createButton" icon="icon-load"></AdaButton>
                <AdaButton title="INTERACTION HINZUFÜGEN" @click="openAddInteractionsDialog" type="createButton"
                           icon="icon-add"></AdaButton>
            </div>
        </div>
        <div>
            <AdaDatatable :columns="columns" :data="[]" :show-pagination="false" :show-search="false"
                          :size-of-page="0">
            </AdaDatatable>
            <InteractionRow v-for="(inter, index) in interactions" v-bind:key="inter.id" :name="inter.name"
                            :technical-name="technicalName + inter.technical_name" :actions="['delete']"
                            @onDelete="removeInteraction(inter)"
                            @moveUp="moveInteractionUp(index)"
                            @moveDown="moveInteractionDown(index)"
                            :description="inter.description" :widths="columns" :hide-move="false">
            </InteractionRow>
            <div class="module-container" v-for="(module,index) in modules" v-bind:key="module.id">
                <SpaceGroupRow style="margin-top: 5px" :text="module.name"
                               :hide-toggle-icon="true"
                               @onDelete="deleteModule(module)"
                               @moveUp="moveUp(index)"
                               @moveDown="moveDown(index)"
                               @onDuplicate="duplicateModule(module)">
                </SpaceGroupRow>
                <InteractionRow v-for="inter in module.interactions" v-bind:key="module.id + '' + inter.id"
                                :name="inter.name"
                                :technical-name="technicalName + '_' + module.technical_name + inter.technical_name"
                                :description="inter.description" :widths="columns">
                </InteractionRow>
            </div>
        </div>
        <AdaButton icon="icon-add" @click="openAddInteractionsDialog" type="fullWidthButton"
                   title="INTERACTION HINZUFÜGEN"></AdaButton>
        <div style="margin-top: 20px">
            <AdaButton :loading="savingTemplate" style="width: 300px; height: 40px" title="SPACE SPEICHERN"
                       @click="createClicked"
                       type="createButton"></AdaButton>
        </div>
        <Dialog v-if="showAddInteractionsDialog" :show-close-button="true" :show="showAddInteractionsDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddInteractionsDialog">
            <SelectInteractionsFromTable :initial-interactions="interactions"
                                         @selected="interactionsSelected"></SelectInteractionsFromTable>
        </Dialog>
        <Dialog v-if="showAddModulesDialog" :show-close-button="true" :show="showAddModulesDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddModulesDialog">
            <SelectModulesFromTable :initial-modules="modules"
                                    @selected="modulesSelected"></SelectModulesFromTable>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Dialog from "../../../components/dialog/Dialog";
    import SelectInteractionsFromTable from "../modules/SelectInteractionsFromTable";
    import SelectModulesFromTable from "./SelectModulesFromTable";
    import SpaceGroupRow from "./SpaceGroupRow";
    import InteractionRow from "./InteractionRow";

    const SpacesRepository = RepositoryFactory.get('spaces');

    export default {
        components: {
            InteractionRow,
            SelectModulesFromTable,
            BreadCrumb,
            AdaDatatable,
            InputFloatLabel,
            SelectInteractionsFromTable,
            AdaButton,
            Dialog,
            SpaceGroupRow
        },
        data: function () {
            return {
                addModuleStyles: {
                    'background-color': '#00b6ed',
                    'border-color': '#00b6ed'
                },
                addInteractionStyles: {
                    'background-color': '#f6f7f8',
                    'border-color': '#f6f7f8',
                    'color': '#d70364'
                },
                modules: [],
                interactions: [],
                showAddInteractionsDialog: false,
                showAddModulesDialog: false,
                spaceName: '',
                technicalName: '',
                columns: [
                    {
                        viewName: 'Name',
                        propName: 'name',
                        width: '25%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        width: '25%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '10%'
                    },
                    {
                        viewName: 'Beschreibung',
                        propName: 'description',
                        width: '40%'
                    }
                ],
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'edit':
                                        res += '<span data-type="edit" class="margin-right hover-highlight icon-edit"></span>';
                                        break;
                                    case 'copy':
                                        res += '<span data-type="duplicate" class="margin-right hover-highlight icon-duplicate"></span>';
                                        break;
                                    case 'delete':
                                        res += '<span data-type="delete" class="margin-right hover-highlight icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    }
                ],
                savingTemplate: false,
                fn:null
            }
        },
        name: "CreateSpaceTemplate",
        mounted() {
            this.fn = () => {
                this.createClicked(true);
            };
            this.$root.$on('saveSpaceTemplate', this.fn);
        },
        beforeDestroy() {
            this.$root.$off('saveSpaceTemplate', this.fn);
        },
        methods: {
            arrayMove(array, from, to) {
                array.splice(to, 0, array.splice(from, 1)[0]);
            },
            moveUp(index) {
                if (index > 0) {
                    this.arrayMove(this.modules, index, index - 1);
                }
            },
            moveDown(index) {
                if (index < this.modules.length - 1) {
                    this.arrayMove(this.modules, index, index + 1);
                }
            },
            moveInteractionUp(index) {
                if (index > 0) {
                    this.arrayMove(this.interactions, index, index - 1);
                }
            },
            moveInteractionDown(index) {
                if (index < this.interactions.length - 1) {
                    this.arrayMove(this.interactions, index, index + 1);
                }
            },
            createClicked(clickedFromHeader = false) {
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', true) : this.savingTemplate = true;
                this.createSpace(clickedFromHeader);
            },
            async createSpace(clickedFromHeader) {
                try {
                    const json = {
                        name: this.spaceName,
                        technical_name: this.technicalName,
                        interactionIds: this.interactions.map(inter => inter.id),
                        moduleIds: this.modules.map(mod => mod.id),
                        is_template: 1
                    };
                    await SpacesRepository.createSpace(json);
                    this.$noty.success("Die Spacevorlage wurde erfolgreich erstellt!");
                    this.$router.push({name: 'templatespaces'});
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Erstellung der Spacevorlage: " + e.message);
                }
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', false) : this.savingTemplate = false;
            },
            interactionsSelected(selectedInteractions) {
                selectedInteractions.forEach(inter => {
                    inter.action = ['copy', 'edit', 'delete'];
                });
                this.interactions = selectedInteractions;
                this.showAddInteractionsDialog = false;
            },
            modulesSelected(selectedModules) {
                selectedModules.forEach(module => {
                    module.action = ['copy', 'edit', 'delete'];
                    module.interactions = module.interactions.sort(this.sortByPivot);
                });
                this.modules = selectedModules;
                this.showAddModulesDialog = false;
            },
            sortByPivot(a, b) {
                if (a.pivot.sort < b.pivot.sort) {
                    return -1;
                }
                if (a.pivot.sort > b.pivot.sort) {
                    return 1;
                }
                return 0;
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'editModule', params: {id: data.row.id}});
                        break;
                    case 'duplicate':
                        this.copyClicked(data.row);
                        break;
                    case 'delete':
                        this.showDeleteCampaignDialog = true;
                        this.deleteCampaign = data.row;
                        break;
                }
            },
            moduleNameChanged(val) {
                this.spaceName = val;
            },
            technicalNameChanged(val) {
                this.technicalName = val;
            },
            openAddInteractionsDialog() {
                this.showAddInteractionsDialog = true;
            },
            closeAddInteractionsDialog() {
                this.showAddInteractionsDialog = false;
            },
            openAddModulesDialog() {
                this.showAddModulesDialog = true;
            },
            closeAddModulesDialog() {
                this.showAddModulesDialog = false;
            },
            removeInteraction(inter) {
                this.interactions.splice(this.interactions.indexOf(inter), 1);
            },
            deleteModule(module) {
                this.modules.splice(this.modules.indexOf(module), 1);
            },
            duplicateModule(module) {
                let nrOfModules = this.getNumberOfModulesById(module.id);
                let newModule = JSON.parse(JSON.stringify(module));
                newModule.name = newModule.name + (nrOfModules + 1);
                this.modules.push(newModule);
            },
            getNumberOfModulesById(id) {
                let count = 0;
                this.modules.forEach(module => {
                    if (module.id === id) {
                        count += 1;
                    }
                });
                return count;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .input-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .item-row {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: white;
        padding: 10px;
        justify-content: space-between;
    }

    .add-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-left: auto;
    }

    .module-container {
        border-top: solid 1px $grey;
        border-bottom: solid 1px $grey;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>